export const staffCaregiverHiringRoutePrefixes = [
  "/care/jobs",
  "/b/:businessUrl/jobs",
  "/b/:businessUrl/manage/jobs",
  "/care/myjobs",
  "/care/claim-resume",
  "/care/marketplace",
  "/care/marketplace/new",
  "/biz/hiring",
  "/biz/marketplace",
  "/biz/staff",
];
